// Angular
import {Injectable} from "@angular/core";
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from "@angular/common/http";
// RxJS
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {environment} from "../../../../../environments/environment";
import {Router} from "@angular/router";
import {LayoutUtilsService, MessageType} from "./layout-utils.service";

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
    constructor(
        private router: Router,
        private layoutUtilsService: LayoutUtilsService
    ) {
    }

    // intercept request and add token
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // tslint:disable-next-line:no-debugger
        // modify request
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${localStorage.getItem(
                    environment.authTokenKey
                )}`,
            },
        });

        return next.handle(request).pipe(
            tap(
                (event) => {
                    if (event instanceof HttpResponse) {
                        // console.log('all looks good');
                        // http response status code
                        // console.log(event.status);
                    }
                },
                (error) => {
                    if (error instanceof HttpErrorResponse) {
                        if (error.status === 401) {
                            this.router.navigateByUrl("/auth/login");
                        }

                        if (error.status === 403) {
                            this.layoutUtilsService.showActionNotification(
                                'No está autorizado para realizar esta acción',
                                MessageType.Read,
                                5000,
                                true,
                                false
                            );
                        }
                    }
                }
            )
        );
    }
}
